module.exports = __webpack_public_path__ + "static/media/tick.674b8892.svg";